import React from 'react';

import { LandingPage } from '../../LandingPage/LandingPage';

export const AuthorisingLandingPage = () => <LandingPage shouldShowLoadingIcon title="Authorising..." qaIdBase="landingPageAuthPending" />;
